import styled from 'styled-components';
import { Container, ContainerContentStandard } from '../../../../../shared/styles/container';
import { Headline } from '../../../../../shared/styles/headline';
import { SubcategoryTagReadOnly } from '../../../../../shared/styles/tag';

export const SubcategoryTagsCentered = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    column-gap: 8px;
    row-gap: 8px;
`;

export const TagCloud = () => {
    const tags = ['Brand Design', 'Editorial Design', 'Grafik & Corporate Design', 'Mediengestaltung', 'Motiondesign/Anmiation & Video',
        'Mobile & Webdesign', 'Packaging Design', 'Präsentationsdesign', 'Produkt-Design', 'Postproduktion/Bildbearbeitung', 'Print-Produktion',
        'Prototyping', 'Reinzeichnung & DTP', 'Service Design', 'UX Design', 'Usability', 'Affiliate-Marketing', 'Amazon Marketing', 'App Marketing', 'Content Marketing', 'Data-Driven Marketing',
        'Digital Marketing', 'Display Marketing', 'E-Commerce', 'E-Mail-Marketing', 'Influencer Marketing', 'Online-Marketing',
        'Performance Marketing', 'Programmatic Advertising', 'SEO', 'SEA', 'SEM', 'Social Media Marketing', 'Content Creator', 'Copy Writer', 'Redaktion', 'Pressearbeit', 'Werbetexter'];

    return (
        <Container centered>
            <ContainerContentStandard>
                <Headline>
                    Wir haben <span>Talente</span> für jedes Gebiet
                </Headline>
                <SubcategoryTagsCentered>
                    {tags.map((tag, index) => <SubcategoryTagReadOnly key={tag + index}>{tag}</SubcategoryTagReadOnly>)}
                </SubcategoryTagsCentered>
            </ContainerContentStandard>
        </Container>
    )
}
